import { ErrorHandler, inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AppLoggerService, LOG_CATEGORY } from './app-logger.service';

/**
 * Central sink for uncaught errors (template errors, unhandled promise rejections, third-party
 * throws). Components and interceptors handle their own expected failures; anything reaching
 * here is a bug, and is reported through {@link AppLoggerService} — do not scatter reporting
 * calls through features.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(AppLoggerService);

  handleError(error: unknown): void {
    const unwrapped =
      error instanceof Error && 'rejection' in error
        ? ((error as Error & { rejection?: unknown }).rejection ?? error)
        : error;

    this.logger.error(LOG_CATEGORY.UNCAUGHT, unwrapped);

    if (!environment.production) {
      console.error('[H4C] Uncaught error', unwrapped);
    }
  }
}
